.tour-maker-highlight-element {
  z-index: 1000000000 !important; }

.tour-disable-pointer-events {
  pointer-events: none; }

.tour-maker-relative-element {
  position: relative; }

.tour-tooltip {
  z-index: 1000000000;
  position: absolute;
  top: 0;
  left: 0; }

.intro-fixparent {
  z-index: auto !important;
  opacity: 1.0 !important;
  transform: none !important;
  will-change: auto !important; }

.tour-maker-disable-element {
  pointer-events: none; }

.tour-maker-disable-element * {
  pointer-events: none; }

.tour-maker-disable-element:before {
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  z-index: 1;
  background: transparent;
  width: 100%; }
